import { StepConfig } from "../../types";
import React, { useCallback } from 'react';

interface Props {
    step: StepConfig;
    index: number;
    isSelected: boolean;
    clickable: boolean;
    onStepSelect: (stepIndex: number) => void
}

export const StepListStep = (props: Props) => {
    const handleClick = useCallback(() => {
        if (props.clickable) {
            props.onStepSelect(props.index);
        }
    }, [props.onStepSelect, props.index, props.clickable]);

    return <div
        style={props.clickable ? { cursor: 'pointer' } : {}}
        onClick={handleClick}
        className={'list-group-item' + (props.isSelected ? ' active' : '')}>
        {props.step.label}
    </div>
}